export const CONFIG = {
  LOCAL_URL: import.meta.env.VITE_LOCAL_URL,
  API_URL: import.meta.env.VITE_API_URL,
  FE_SUPPORT_URL: import.meta.env.VITE_FE_SUPPORT_URL,
  API_GATEWAY_URL: import.meta.env.VITE_API_GATEWAY_URL,
  MERCHANT_API_URL: import.meta.env.VITE_MERCHANT_API_URL,
  // The account app (ext-acct-lifecycle-mgmt-ui) for this environment
  ACCOUNT_APP_URL: import.meta.env.VITE_ACCOUNT_APP_URL,
  // Where partner users are sent. The same public site in every environment.
  REACH_SITE_URL: 'https://withreach.com',

  /* Because our endpoints are locked to their respective domains, we need to
   * store these in localStorage for development purposes only.
   * In production, these will be set via environment variables during build time.
   */
  // Used for PBI embedding
  ENGINE_URL:
    localStorage.getItem('ADMIN_API_URL') ||
    import.meta.env.VITE_ENGINE_API_URL,
  FRONTEGG: {
    baseUrl: import.meta.env.VITE_FRONTEGG_BASE_URL,
    clientId: import.meta.env.VITE_FRONTEGG_CLIENT_ID,
  },
  DATADOG: {
    applicationId: import.meta.env.VITE_DATADOG_APPLICATION_ID,
    clientToken: import.meta.env.VITE_DATADOG_CLIENT_TOKEN,
    site: import.meta.env.VITE_DATADOG_SITE || 'datadoghq.com',
    service: import.meta.env.VITE_DATADOG_SERVICE || 'ext-app-int-dashboard',
    env:
      import.meta.env.VITE_DATADOG_ENV || import.meta.env.MODE || 'development',
    sessionSampleRate:
      Number(import.meta.env.VITE_DATADOG_SESSION_SAMPLE_RATE) || 100,
    sessionReplaySampleRate:
      Number(import.meta.env.VITE_DATADOG_SESSION_REPLAY_SAMPLE_RATE) || 100,
  },
}
